import { Configuration, Middleware } from "../lib/cnb/api/public";
import { apiServerErrorHandlingMiddleware } from "./apiServerErrorHandlingMiddleware";
import { userManager } from "../auth/oauth2/userManager";
import { oauth2Enabled } from "../auth/oauth2/oauth2Config";

const bearerTokenMiddleware: Middleware = {
  pre: async (context) => {
    if (!oauth2Enabled) return;
    const user = await userManager.getUser();
    if (!user?.access_token) return;
    return {
      url: context.url,
      init: {
        ...context.init,
        headers: {
          ...(context.init.headers as Record<string, string> | undefined),
          Authorization: `Bearer ${user.access_token}`,
        },
      },
    };
  },
};

export const apiConfig = new Configuration({
  credentials: "include", // Set the credentials option to "include"
  basePath: process.env.REACT_APP_API_URL,
  middleware: [apiServerErrorHandlingMiddleware, bearerTokenMiddleware],
});
